import React from "react";

/**
 * Native port of ``cms/blocks/hc-block/hc-block--gray-testimonials.html``.
 *
 * This "hardcoded template" is purely a ``<style>`` block that restyles the
 * Reviews module (a TERRIBLE precedent, per the legacy comment, but preserved
 * faithfully). The legacy HTML comments are visually inert and omitted.
 */
const CSS = `
    .block-reviews .pdp-section {
        display: flex;
        flex-direction: column;
        padding: 4rem 0 3.75rem 0;
    }

    .block-reviews .pdp-section > a:first-of-type {
        display: none;
    }

    .block-reviews .pdp-section .button {
        align-self: center;
        margin: 3rem 0 0 0;
        order: 5;
    }

    .block-reviews .pdp-section__title {
        line-height: 0;
        text-indent: -9999em;
    }

    .block-reviews .pdp-section__title:after {
        content: "Sleepers Love Our Adjustable Bases";
        display: block;
        line-height: initial;
        text-indent: 0;
    }
`;

export const GrayTestimonials = (): React.JSX.Element => (
    <style type="text/css">{CSS}</style>
);
